import LiveProjectTable from "@/components/LiveProjectTable";

export default function Orders() {
  return <LiveProjectTable />;
}
